var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.4375 7.375V16.55C28.4375 17.0625 28.0125 17.4875 27.5 17.4875C26.9875 17.4875 26.5625 17.0625 26.5625 16.55V7.8L16.125 14.05C15.775 14.2625 15.3875 14.3625 15 14.3625C14.6125 14.3625 14.225 14.2625 13.875 14.05L3.4375 7.8V19.875C3.4375 21.425 4.7 22.6875 6.25 22.6875H10C10.5125 22.6875 10.9375 23.1125 10.9375 23.625C10.9375 24.1375 10.5125 24.5625 10 24.5625H6.25C3.6625 24.5625 1.5625 22.4625 1.5625 19.875V7.375C1.5625 4.7875 3.6625 2.6875 6.25 2.6875H23.75C26.3375 2.6875 28.4375 4.7875 28.4375 7.375ZM24.4125 19.2125C24.05 18.85 23.45 18.85 23.0875 19.2125C22.725 19.575 22.725 20.175 23.0875 20.5375L25.2375 22.6875H15C14.4875 22.6875 14.0625 23.1125 14.0625 23.625C14.0625 24.1375 14.4875 24.5625 15 24.5625H25.2375L23.0875 26.7125C22.725 27.075 22.725 27.675 23.0875 28.0375C23.275 28.225 23.5125 28.3125 23.75 28.3125C23.9875 28.3125 24.225 28.225 24.4125 28.0375L28.1625 24.2875C28.525 23.925 28.525 23.325 28.1625 22.9625L24.4125 19.2125Z",
    fill: "#0069AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendLink);
export default __webpack_public_path__ + "static/media/send-link.b7ec1702abe86df7416744666ac08fe1.svg";
export { ForwardRef as ReactComponent };